import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { OSSUpload } from './components/upload';
export const CnOSSUpload = withI18n(OSSUpload, {
    locale,
    componentName: 'CnOSSUpload',
    _noHoc: true,
});
